<template>
  <transition name="fade">
    <md-action-sheet
      class="common-action-sheet"
      v-model="open"
      :title="title"
      :cancel-text="cancelText"
      :actions="list"
      @choose="handlerToChoose"
      @cancel="handlerToCancel"
      :active="active"
    ></md-action-sheet>
  </transition>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    open: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '请选择'
    },
    active: {
      type: Number,
      default: 0
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {
    open(newValue, oldValue) {
      if (newValue) {
        document
          .getElementsByTagName('body')[0]
          .classList.add('fixed', 'hidden')
      } else {
        document
          .getElementsByTagName('body')[0]
          .classList.remove('fixed', 'hidden')
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {
    document.getElementsByTagName('body')[0].classList.remove('fixed', 'hidden')
  },
  methods: {
    handlerToCancel() {
      this.$emit('cancel', !this.open)
    },
    handlerToChoose(item, index) {
      this.$emit('choose', item, index)
    }
  }
}
</script>

<style lang="css">
.common-action-sheet .md-actionsheet .md-actionsheet__item.is-active {
  color: #191f25 !important;
}
</style>
